import { datadogLogs } from '@datadog/browser-logs';

import { noop } from 'helpers/noop';

import { castError } from './castError';
import { getIsDocumentDefined } from './getIsDocumentDefined';
import { LoggerGenericFn, LoggerMethod } from './loggerTypes';

export const getBoundDatadogLogs = (method: LoggerMethod): LoggerGenericFn => {
  if (!getIsDocumentDefined()) return noop;

  const boundLogger = datadogLogs.logger[method].bind(datadogLogs.logger);

  return (message, data) =>
    boundLogger(
      // 1. message
      message,
      // 2. context
      // NOTE: context has reserved fields, so we place our own in `extra`
      data?.extra ? { extra: data.extra } : undefined,
      // 3. error
      castError(data?.error)
    );
};
